
import { TOGGLE_MODAL } from './Constants'

const initialState = {
	modal: {
		visible: false,
		data:    null
	}
}

export function appReducer(state = initialState, action) {
  switch(action.type) {
		case TOGGLE_MODAL:
			let thereIsData = action.payload && action.payload.data
      return {
        ...state, 
        modal: {
					visible: !state.modal.visible,
					data: 		thereIsData ? action.payload.data : state.modal.data
				}
      }
    default:
      return state
  }
}

export default appReducer